import { useEffect } from 'react'
import { useDesignStore } from '../store/designStore'

export const useKeyboardShortcuts = () => {
  const { selectedObjects, deleteObject, undo, redo, clearSelection } = useDesignStore()

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Prevent shortcuts when typing in inputs
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
        return
      }

      const { key, ctrlKey, metaKey, shiftKey } = event
      const isModifierPressed = ctrlKey || metaKey

      switch (key) {
        case 'Delete':
        case 'Backspace':
          if (selectedObjects.length > 0) {
            event.preventDefault()
            selectedObjects.forEach(obj => deleteObject(obj.id))
          }
          break

        case 'z':
          if (isModifierPressed && !shiftKey) {
            event.preventDefault()
            undo()
          } else if (isModifierPressed && shiftKey) {
            event.preventDefault()
            redo()
          }
          break

        case 'y':
          if (isModifierPressed) {
            event.preventDefault()
            redo()
          }
          break

        case 'Escape':
          event.preventDefault()
          clearSelection()
          break

        case 'a':
          if (isModifierPressed) {
            event.preventDefault()
            // Could implement "select all" functionality here
          }
          break

        default:
          break
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [selectedObjects, deleteObject, undo, redo, clearSelection])
}

export default useKeyboardShortcuts
